import { ProcdureInitiativeService as OvermapProcedureInitiativeService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureInitiativeService extends OvermapProcedureInitiativeService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
